import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ContractEnvelopeValidationSchema } from '@/features/privateCompanyLeadsFunnel/schemas/contractEnvelope.schema'
import { useMutation } from '@tanstack/react-query'

interface UseUpdateContractEnvelopeProps {
  id?: string
  file?: Blob
  onSuccess: () => void
  onError: (error: any) => void
}

export const useUpdateContractEnvelope = ({ id, file, onSuccess, onError }: UseUpdateContractEnvelopeProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateContractEnvelope'],
    mutationFn: async (form: ContractEnvelopeValidationSchema) => {
      const private_company_lead = {
        contract_attributes: {
          valid_envelope_attributes: {
            file_to_sign: file ? file : undefined,
            contractee_attributes: form.contract_attributes?.valid_envelope_attributes?.contractee_attributes
              ?.signable_id?.value
              ? {
                  signable_id:
                    form.contract_attributes?.valid_envelope_attributes?.contractee_attributes?.signable_id?.value,
                  signable_type: 'SignableContract::DefaultSigner',
                }
              : {
                  _destroy: true,
                },
            contractor_attributes: form.contract_attributes?.valid_envelope_attributes?.contractor_attributes
              ?.signable_id?.value
              ? {
                  signable_id:
                    form.contract_attributes?.valid_envelope_attributes?.contractor_attributes?.signable_id?.value,
                  signable_type: 'Funnel::Contact',
                }
              : {
                  _destroy: true,
                },
            surety_attributes: form.contract_attributes?.valid_envelope_attributes?.surety_attributes?.signable_id
              ?.value
              ? {
                  signable_id:
                    form.contract_attributes?.valid_envelope_attributes?.surety_attributes?.signable_id?.value,
                  signable_type: 'Funnel::Contact',
                }
              : {
                  _destroy: true,
                },
          },
        },
      }

      await privateAxios.putForm(`/funnel/private_company_leads/${id}`, {
        private_company_lead,
      })
    },
    onSuccess,
    onError,
  })
}
